// extracted by mini-css-extract-plugin
export var numpadContainer = "_nk-1";
export var phoneButton = "_nk-0";